var styles = {"wrapper":"styles_wrapper__2y8E7","loader":"styles_loader__MlXOX mx-auto"};

export default styles;
//# sourceMappingURL=styles.css.js.map
